import { connect } from "react-redux";
import { compose } from "redux";

import { getNationalTeamMatches, resetNationalTeamMatches } from "./actions";
import Component from "./nationalTeamMatches";
import {
  makeSelectIsError,
  makeSelectIsReady,
  makeSelectNextPage,
  makeSelectTeamMatches,
} from "./reducer";

const makeMapStateToProps = () => {
  const selectTeamMatches = makeSelectTeamMatches();
  const selectIsReady = makeSelectIsReady();
  const selectIsError = makeSelectIsError();
  const selectNextPage = makeSelectNextPage();
  const mapStateToProps = (state, ownProps) => ({
    isReady: selectIsReady(state, ownProps),
    isError: selectIsError(state, ownProps),
    matches: selectTeamMatches(state, ownProps),
    nextPage: selectNextPage(state, ownProps),
  });

  return mapStateToProps;
};

const mapDispatchToProps = (dispatch) => ({
  onGetNationalTeamMatches: (data) => dispatch(getNationalTeamMatches(data)),
  onResetNationalTeamMatches: (data) =>
    dispatch(resetNationalTeamMatches(data)),
});

export default compose(connect(makeMapStateToProps, mapDispatchToProps))(
  Component
);
